import { useGetOne, useRecordContext } from 'react-admin';
import { CumulativeReportSummary } from 'types/embedded/cumulativeReport';
import { MerchantAccount } from 'types/embedded/merchantAccount';
import { convertReactAdminIdToHydraId } from 'utils';

import { TypographyStyled } from './CumulativeReportSummary.styled';

type Props = {
  label: string;
  onClick: (record?: MerchantAccount) => void;
  source?: string;
};

export const CumulativeReportSummaryMerchantAccountField: React.FC<Props> = ({ onClick }) => {
  const record = useRecordContext<CumulativeReportSummary>();
  const { data: merchantAccount } = useGetOne<MerchantAccount>(
    'merchant_accounts',
    {
      id: record && convertReactAdminIdToHydraId(record?.merchantAccountId, 'merchant_accounts'),
    },
    { enabled: !!record },
  );

  return (
    <TypographyStyled onClick={() => onClick(merchantAccount)}>
      {record?.merchantAccountName}
    </TypographyStyled>
  );
};
